import { tickerHeadlines } from "@/mocks/news";

export default function Ticker() {
  const doubled = [...tickerHeadlines, ...tickerHeadlines];
  return (
    <div className="relative border-b border-primary-100 bg-primary-600">
      <div className="flex items-stretch">
        <div className="relative z-10 flex shrink-0 items-center gap-2 bg-foreground-950 px-4 py-2.5 text-background-50 md:px-6">
          <i className="ri-flashlight-fill text-accent-300" aria-hidden="true"></i>
          <span className="whitespace-nowrap text-sm font-bold tracking-wide">热点速报</span>
        </div>
        <div className="relative flex min-w-0 flex-1 items-center overflow-hidden px-0">
          <div className="ticker-track">
            {doubled.map((t, i) => (
              <span key={i} className="flex items-center whitespace-nowrap px-8 text-[13px] font-medium text-background-50/95">
                <i className="ri-arrow-right-up-fill mr-2 text-accent-200" aria-hidden="true"></i>
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}